export const listColumnsSize = {
  title: null,
};
